import { Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderStatusProviderService } from '../providers';
import { OrderStatus } from '../enums';

@Pipe({
  name: 'orderStatus',
})
export class OrderStatusPipe implements PipeTransform {
  private readonly provider = inject(OrderStatusProviderService);

  public transform(status: OrderStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
